import { render, staticRenderFns } from "./Inspeccion.vue?vue&type=template&id=2bc35a44&"
import script from "./Inspeccion.vue?vue&type=script&lang=js&"
export * from "./Inspeccion.vue?vue&type=script&lang=js&"
import style0 from "./Inspeccion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports